<template>
  <v-dialog v-model="dialogStatus"
            persistent
            max-width="1000px">
    <div class="fill-height">


      <v-card class="fill-height">
        <v-card-title>
          <v-chip small color="primary">جزئیات حساب</v-chip>
          <v-spacer/>
          <v-btn style="background-color:#be1e0b" dark icon small @click.stop="closed">
            <v-icon>mdi-close</v-icon>
          </v-btn>

        </v-card-title>
        <v-card-text>
          <v-expansion-panels v-if="userType==='user'" flat>
            <v-expansion-panel>
              <v-expansion-panel-header>
                <v-col sm="3">
                  <v-chip color="warning" small>درخواست بررسی</v-chip>
                </v-col>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <!--                  <v-card flat>-->
                <v-textarea v-model="text" outlined dense>
                </v-textarea>
                <v-card-actions dir="ltr">
                  <v-btn small color="primary" @click="sendRequest">ارسال</v-btn>
                </v-card-actions>
                <!--                  </v-card>-->

              </v-expansion-panel-content>

            </v-expansion-panel>
          </v-expansion-panels>
        </v-card-text>

        <v-card-text>
          <!--          <v-row>-->

          <!--          </v-row>-->
          <!--          <div class="table-wrapper">-->
          <b-table
              v-if="can('accountList')"
              :items="model.accountTempList"
              :fields="columns"
              stacked="md"
              show-empty
              responsive
              striped
              class="fixed-header-table"
              style="font-size: 15px;color: black"
          >
            <template #cell(remainder)="row">
              <span v-if="row.item.remainder && row.item.remainder.includes('-')"
                    style="color: red">{{ row.item.remainder }}</span>
              <span v-if="row.item.remainder && !row.item.remainder.includes('-')">{{ row.item.remainder }}</span>

            </template>
            <template #cell(sumCreditor)="row">
              <span v-if="row.item.sumCreditor!=='0'" style="color: green">{{ row.item.sumCreditor }}</span>
              <span v-if="row.item.sumCreditor==='0'">{{ row.item.sumCreditor }}</span>
            </template>
            <template #cell(sumDebtor)="row">
              <span v-if="row.item.sumDebtor!=='0'" style="color: blue">{{ row.item.sumDebtor }}</span>
              <span v-if="row.item.sumDebtor==='0'">{{ row.item.sumDebtor }}</span>
            </template>

            <template v-slot:top-row>
              <td style="border: none!important;"></td>
              <td style="border: none!important;"></td>
              <td style="border: none!important;"></td>
              <td style="border: none!important;"></td>
              <td style="border: none!important;">
                <strong>مانده :
                  <strong v-if="model.sumRemainder && model.sumRemainder.includes('-')"
                          style="color: red">{{ model.sumRemainder }} </strong>
                  <strong
                      v-if="model.sumRemainder && !model.sumRemainder.includes('-')">{{ model.sumRemainder }} </strong>
                  ریال
                </strong>

              </td>


            </template>

          </b-table>
          <!--          </div/>-->
          <v-btn color="primary" @click="show_()">
            <span v-if="!showAll">نمایش بیشتر</span>
            <span v-if="showAll">نمایش کمتر</span>
          </v-btn>
        </v-card-text>
      </v-card>
    </div>
  </v-dialog>
</template>

<script>


import Request_se from "@/views/define/requestUser/Request_se";
import Account_se from "@/views/define/account/Account_se";

export default {

  props: {
    dialogStatus: {
      default: false,
    },
    model: Object,
    userType: String
  },
  data() {
    return {
      text: '',
      showAll: false,
      columns: [
        {key: 'article', label: 'شرح پرداخت'},
        {key: 'date', label: 'تاریخ', },
        {key: 'sumDebtor', label: 'بدهکار(ریال)'},
        {key: 'sumCreditor', label: 'بستانکار(ریال)'},
        {key: 'remainder', label: 'مانده(ریال)'},

      ],
    }
  },


  methods: {

    closed() {
      this.showAll = false
      this.$emit('update:dialogStatus', false)
      this.$root.$emit('Account')
    },
    show_: function () {
      this.showAll = !this.showAll
      this.modelId = this.model.id;
      Account_se.getDetails(this.modelId, this.showAll).then(response => {
        this.model = response.data
      })
      this.showDialog = true;
    },
    sendRequest() {
      Request_se.save(this.text, this.model.unit.id, this.model.user.id).then(response => {
        if (response && response.status === 200) {
          this.text = ""
          this.$snack({type: 'success'})
        }
      })
    },

  },


}
</script>
<style>
.fixed-header-table {
  display: block;
}

.fixed-header-table thead {
  display: table;
  width: 100%;
  table-layout: fixed;
}

.fixed-header-table tbody {
  display: block;
  max-height: 450px; /* ارتفاع دلخواه */
  overflow-y: auto;
  width: 100%;
}

.fixed-header-table tbody tr {
  display: table;
  width: 100%;
  table-layout: fixed;
}


</style>

